<template>
    <div class="site">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>场地管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>场地列表</h2>
                <div class="item" v-if="role_id!=4||(role_id==4&&hasCreat)" @click="add"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增场地</div>
                <div class="item" v-if="role_id!=4||(role_id==4&&hasCreat)" @click="seeType"><i class="icon el-icon-circle-plus-outline" type="primary"></i>场地类型</div>
                <div class="item" v-if="role_id!=4||(role_id==4&&hasCreat)" @click="seeManage"><i class="icon el-icon-circle-plus-outline" type="primary"></i>场地管理员</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" class="demo-form-inline" size="mini">
                    <el-form-item label="城市名称" v-if="role_id==1">
                        <el-select v-model="form.city_id" clearable @clear="getSiteList()"  filterable placeholder="输入城市关键字"  style="width: 150px;">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="场地类别">
                        <el-select v-model="form.cate_id" clearable @clear="getSiteList()"  filterable placeholder="输入类别关键字"  style="width: 150px;">
                            <el-option
                                    v-for="item in spaceList"
                                    :key="item.cate_id"
                                    :label="item.name"
                                    :value="item.cate_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" >
                        <el-select v-model="form.status" clearable @clear="getSiteList()" placeholder="请选择">
                            <el-option value="1" label="已审核"></el-option>
                            <el-option value="-1" label="待审核"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="场地名称" >
                        <el-input v-model="form.space_name" clearable style="width: 200px;" placeholder="场地名称" clearable @clear="getSiteList()"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="siteList" size="mini" border style="width: 100%"  v-loading="loading">
                    <el-table-column prop="space_name" label="场地名称" align="center"/>
                    <el-table-column prop="city" label="所属城市" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.big_city_name}} {{scope.row.city}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cate_name" label="场地类型" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.big_cate_name}} {{scope.row.cate_name}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column prop="size" label="场地尺寸" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.size_length}}*{{scope.row.size_width}}</span><span v-if="scope.row.size_height>0">*{{scope.row.size_height}}</span>(m)
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="场地面积" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.area}}m²</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="日价格" align="center"/>
                    <el-table-column prop="price_s" label="周价格" align="center"/>
                    <el-table-column prop="floor_price" label="月价格" align="center"/>
<!--                    <el-table-column prop="contact_name" label="场地管理员" align="center" v-if="role_id!=4||(role_id==4&&hasSee)" />-->
<!--                    <el-table-column prop="contact_phone" label="管理员电话" align="center"  v-if="role_id!=4||(role_id==4&&hasSee)"/>-->
                    <el-table-column prop="area" label="是否显示" align="center">
                        <template slot-scope="scope">
                            <el-switch  v-model="scope.row.is_show==1?true:false" @change="changeStatus(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="是否置顶" align="center">
                        <template slot-scope="scope">
                            <el-switch  v-model="scope.row.is_hot==1?true:false" @change="changeHot(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="排序" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sort" placeholder="序号" @change="updateSort(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="状态" align="center">
                        <template slot-scope="scope">
                           <span v-if="scope.row.status<1">待审</span>
                           <span v-else>审核通过</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="240px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail(scope.row)">查看详情</el-button>
                            <el-button type="text" size="small" @click="pass(scope.row)"  v-if="scope.row.status<1&&(role_id!=4||(role_id==4&&hasCheck))">通过</el-button>
                            <el-button type="text" size="small" @click="see(scope.row)"  v-if="scope.row.status<1&&(role_id!=4||(role_id==4&&hasCheck))">查看原文链接</el-button>
                            <el-button type="text" size="small" @click="refuse(scope.row)" v-if="scope.row.status<1&&(role_id!=4||(role_id==4&&hasCheck))">拒绝</el-button>
                            <el-button type="text" size="small" @click="updateRow(scope.row)"  v-if="role_id!=4||(role_id==4&&hasUpdate)">修改</el-button>
                            <el-button type="text" size="small" @click="deleRow(scope.row)"   v-if="role_id!=4||(role_id==4&&hasDel)">删除</el-button>
                            <el-button type="text" size="small" @click="addCase(scope.row)">案例</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
                        :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>



        <el-dialog
                title="场地详情"
                :visible.sync="infoPop"
                width="500px"
                >
            <div class="info-box" style="text-align: left">
                <p class="item"><span class="info-tit">场地名称：</span><span class="val">{{infoData.space_name}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">场地类别：</span><span class="val">{{infoData.big_city_name}}</span></p>
                    <p><span class="info-tit">场地小类：</span><span class="val">{{infoData.cate_name}}</span></p>
                </div>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">场地尺寸：</span><span class="val">{{infoData.size}}(单位:m)</span></p>
                    <p><span class="info-tit">场地面积：</span><span class="val">{{infoData.area}}m²</span></p>
                </div>
                <div class=" item d_flex j_b">
                    <p><span class="info-tit">日价格：</span><span class="val">&yen;{{infoData.price}}</span></p>
                    <p><span class="info-tit">周价格：</span><span class="val">&yen;{{infoData.price_s}}</span></p>
                </div>
                <p class="item">
                  <span class="info-tit">营业时间：</span><span class="val">{{infoData.business_time}}</span>
                </p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">所属城市：</span><span class="val">{{infoData.big_city_name}}</span></p>
                    <p><span class="info-tit">所属区域：</span><span class="val">{{infoData.city}}</span></p>
                </div>
                <p class="item"><span class="info-tit">详细地址：</span><span class="val">{{infoData.address}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">场地方：</span><span class="val">{{infoData.contact_name}}</span></p>
                    <p><span class="info-tit">职位：</span><span class="val">{{infoData.contact_position}}</span></p>
                </div>
                <div class="item d_flex j_b" v-if="(role_id!=4||(role_id==4&&hasSee))">
                    <p><span class="info-tit">场地对接人微信：</span><span class="val">{{infoData.contact_wx}}</span></p>
                    <p><span class="info-tit">场地对接人电话：</span><span class="val">{{infoData.contact_phone}}</span></p>
                </div>
                <div class="site-img-box">
                    <p>场地平面图</p>
                    <div class="swiper" v-if="infoData.plan">
                        <mu-carousel>
                                <mu-carousel-item v-for="(item,i) in infoData.plan.split(',')" :key="i">
                                <img :src="item|handleImg" @click="previewIMg(baseUrl+item)">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                    <p>场地介绍图</p>
                    <div class="swiper"  v-if="infoData.cover">
                        <mu-carousel>
                            <mu-carousel-item v-for="(item,i) in infoData.cover.split(',')" :key="i">
                                <img :src="item|handleImg" @click="previewIMg(baseUrl+item)">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                    <p>场地相册</p>
                    <div class="swiper"  v-if="infoData.photo">
                        <mu-carousel>
                            <mu-carousel-item v-for="(item,i) in infoData.photo" :key="i">
                                <img :src="item.path|handleImg"  @click="previewIMg(baseUrl+item.path)">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="infoPop = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="拒绝原因"
                :visible.sync="refusePop"
                width="500px"
                style="text-align: left"
        >
            <div class="pop-box">
                <el-input type="textarea" v-model="remark" maxlength="100" placeholder="请输入拒绝原因" style="margin-bottom:20px ;"></el-input>
                <div class="btn-box">
                    <el-button type="primary" @click="subRefuse">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
                :visible.sync="imgPop"
                width="800px"
                style="text-align: center;"
        >
            <img :src="preImg" alt="" style="width: 100%;">
        </el-dialog>
        <
    </div>
</template>

<script>
    import {getSiteList,delSite,spacecateList,setStatus,updateSiteCase} from '../../api/site'
    import {searchCity} from '../../api/city'
    import { mapState } from 'vuex';
    export default {
        name: "site",
        data(){
            return{
                siteList:[],
                spaceList:[],
                cityList:[],
                loading:false,
                infoPop:false,
                page:1,
                pages:1,
                form:{
                    space_name:'',
                    city_id:'',
                    cate_id:'',
                    status:''
                },
                infoData:'',
                remark:'',
                refuseData:'',
                refusePop:false,
                role_id:0,
                role_ads:[],
                userinfo:'',
                hasCreat:false,
                hasDel:false,
                hasUpdate:false,
                hasCheck:false,
                hasSee:false,
                imgPop:false,
                preImg:"",
                loading: '',
            }
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        mounted(){
            this.role_id=localStorage.getItem('ROLE');
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            this.role_ads=JSON.parse(localStorage.getItem('USERINFO')).role_adm_access_ids;
            if(this.role_ads.length>0){
               this.hasCreat= this.role_ads.includes('17');
               this.hasUpdate= this.role_ads.includes('18');
               this.hasDel= this.role_ads.includes('19');
               this.hasCheck= this.role_ads.includes('20');
               this.hasSee= this.role_ads.includes('21');
            }
            this.getSiteList();
            this.searchCity();
            this.spacecateList();
        },
        watch:{
          $route(to,from){
              console.log(from);
              if(from.query.page){
                  this.page=from.query.page;
                  this.getSiteList();
              }
          }
        },
        methods:{
            getSiteList(){
                this.loading=true;
                let data={
                    p:this.page,
                    ...this.form
                };
                getSiteList(data).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.siteList=res.data.list;
                        this.pages=res.data.total_num;
                        console.log(this.pages);
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            spacecateList(){
                spacecateList().then(res=>{
                    if(res.code==1){
                        this.spaceList=res.data
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        this.cityList=res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            updateRow(row){
                localStorage.setItem('update_site',JSON.stringify(row))
                this.$router.push({path: '/site/add-site',query:{type:1,page:this.page}});
            },
            pass(row){
                setStatus({
                    space_id:row.space_id,
                    status:1
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.getSiteList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            refuse(row){
                this.refusePop=true;
                this.refuseData=row;
            },
            subRefuse(){
                if(!this.remark){
                    this.$message.error('请输入拒绝原因');
                    return;
                }
                setStatus({
                    space_id:this.refuseData.space_id,
                    status:8,
                    remark:this.remark
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.refusePop=false;
                        this.getSiteList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            deleRow(row){
                this.$confirm('此操作将永久删除该场地, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delSite({space_id:row.space_id}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getSiteList();
                        }
                    })
                }).catch((err) => {
                    this.$message.error(err.msg);
                });
            },
            detail(row){
                this.infoData=row;
                this.infoPop=true;
            },
            onSubmit(){
                this.getSiteList()
            },
            add(){
                this.$router.push({path: '/site/add-site'});
            },
            seeType(){
                this.$router.push({path: '/site/list'});
            },
            seeManage(){
                this.$router.push({path: '/site/mlist'});
            },
            toType(){
                this.$router.push({path: '/site/list'});
            },
            handleCurrentChange(val){
                this.page = val;
                this.getSiteList()
            },
            addCase(row){
                this.$router.push({path: '/uploadFile/index',query:{id:row.space_id,name:row.space_name,page:this.page}});
            },
            previewIMg(img){
                this.imgPop=true;
                this.preImg=img;
            },
            changeStatus(row){
               updateSiteCase({
                   space_id:row.space_id,
                   is_show:row.is_show==1?2:1,
                   is_hot:row.is_hot?1:0,
                   sort:row.sort,
               }).then(res=>{
                   if(res.code==1){
                       this.$message.success('修改成功');
                       this.getSiteList();
                   }else{
                       this.$message.error(res.msg);
                   }
               })
            },
            changeHot(row){
                console.log(row)
                updateSiteCase({
                    space_id:row.space_id,
                    is_hot:row.is_hot?0:1,
                    is_show:row.is_show==1?1:2,
                    sort:row.sort,
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.getSiteList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            updateSort(row){
                updateSiteCase({
                    space_id:row.space_id,
                    is_hot:row.is_hot?1:0,
                    is_show:row.is_show==1?1:2,
                    sort:row.sort,
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.getSiteList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            see(row){
                window.open('https://cdb.0731app.cn/wx/space/cinfo?space_id='+row.space_id)
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-content{
    padding: 20px;
    .table{
        padding: 20px;
        background-color: #fff;
        text-align: left;
        box-shadow: 0 4px 4px 0 #e1e5eb;
    }
}
.info-box{
    .item{
        padding: 10px 0;
        .info-tit{
            font-size: 15px;
            color: #999999;
        }
        .val{
            color: #ff6b11;
        }
    }
    .site-img-box{
        p{
            font-size: 18px;
            color: #333333;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .mu-carousel{
            width: 100%;
            height: 300px;
        }
    }
}
</style>
